<template>
    <div class="error-message">
        <base-icon
            :name="icon.name"
            :size="icon.size"
            :color="icon.color"
        ></base-icon>

        <slot name="title"></slot>
        <slot name="subtitle"></slot>
        <slot name="component"></slot>
    </div>
</template>

<script>
export default {
    name: 'ErrorMessage',

    components: {
        BaseIcon: () => import (/* webpackChunkName: "BaseIcon"*/ '@RepoComponent/BaseIcon/BaseIcon.vue'),
    },

    props: {
        icon: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style src="./ErrorMessage.scss" lang="scss"></style>
